module.exports = __webpack_public_path__ + "static/media/Concordia_logo.ce2b73b8.jpg";